<template>
    <div>
        <v-card class="my-4">
            <v-card-title>
                Bemanning vecka {{ (new Date()).getWeekNumber() }}
            </v-card-title>
            <v-card-text>
                <div v-for="(day, i) in days" :key="day.id">
                <Day
                    :date="day.date"
                    :day="day"
                    :width="chartWidth"
                    class="my-4" />
                    <v-divider v-if="i < days.length-1" />
                </div>
            </v-card-text>
        </v-card>

        <v-card class="my-4">
            <v-card-title>
                Viktiga kontakter
            </v-card-title>
            <v-card-text>
                <Information />
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import Day from "../Day"
import Information from "../Information"

export default {
    name: 'Schedule',
    components: {
        Day,
        Information,
    },
    data() {
        return {
            days: [
                {
                    id: 1,
                    date: new Date().addDays(0),
                    note: "Aska kl. 10",
                    persons: [
                    {
                        id: 1,
                        name: "Anders Bengtsson",
                        phoneNumber: "070-695 57 66",
                        role: {
                        name: "Rescue runner",
                        color: "lightgreen"
                        },
                        periods: [
                        {
                            id: 333333333,
                            start: {
                            hour: 0,
                            minute: 0,
                            },
                            end: {
                            hour: 12,
                            minute: 0,
                            },
                        },
                        {
                            id: 333232323,
                            start: {
                            hour: 14,
                            minute: 0,
                            },
                            end: {
                            hour: 22,
                            minute: 0,
                            },
                        },
                        ],
                    },
                    {
                        id: 2,
                        name: "Cecilia Davidsson",
                        role: {
                        name: "Captain",
                        color: "lightblue"
                        },
                        periods: [
                        {
                            id: 22323,
                            start: {
                            hour: 0,
                            minute: 0,
                            },
                            end: {
                            hour: 14,
                            minute: 0,
                            },
                        }
                        ]
                    },
                    {
                        id: 3,
                        name: "Erik Fredriksson",
                        role: {
                        name: "Pupil",
                        color: "pink"
                        },
                        periods: [
                        {
                            start: {
                            hour: 0,
                            minute: 0,
                            },
                            end: {
                            hour: 24,
                            minute: 0,
                            },
                        }
                        ]
                    },
                    
                    ]
                },
            {
                id: 2,
                date: new Date().addDays(1),
                persons: []
            },
            {
                id: 3,
                date: new Date().addDays(2),
                persons: [
                {
                    id: 1,
                    name: "Anders Bengtsson",
                    role: {
                    name: "Rescue runner",
                    color: "lightgreen"
                    },
                    periods: [
                    {
                        id: 333333333,
                        start: {
                        hour: 0,
                        minute: 0,
                        },
                        end: {
                        hour: 24,
                        minute: 0,
                        },
                    },
                    ],
                },
                {
                    id: 2,
                    name: "Cecilia Davidsson",
                    role: {
                    name: "Captain",
                    color: "lightblue"
                    },
                    periods: [
                    {
                        id: 22323,
                        start: {
                        hour: 0,
                        minute: 0,
                        },
                        end: {
                        hour: 14,
                        minute: 0,
                        },
                    },
                    {
                        id: 2264653,
                        start: {
                        hour: 16,
                        minute: 15,
                        },
                        end: {
                        hour: 24,
                        minute: 0,
                        },
                        comment: "Endast prio 1-larm",
                    },
                    ]
                },
                {
                    id: 3,
                    name: "Greta Henriksson",
                    role: {
                    name: "Pupil",
                    color: "pink"
                    },
                    periods: [
                    {
                        start: {
                        hour: 0,
                        minute: 0,
                        },
                        end: {
                        hour: 24,
                        minute: 0,
                        },
                    }
                    ]
                },
                ]
            },
            {
                id: 4,
                date: new Date().addDays(3),
                note: "Övning kl. 16:30",
                persons: [
                {
                    id: 1,
                    name: "Anders Bengtsson",
                    role: {
                    name: "Rescue runner",
                    color: "lightgreen"
                    },
                    periods: [
                    {
                        id: 333333333,
                        start: {
                        hour: 8,
                        minute: 0,
                        },
                        end: {
                        hour: 24,
                        minute: 0,
                        },
                    },
                    ],
                },
                {
                    id: 2,
                    name: "Cecilia Davidsson",
                    role: {
                    name: "Captain",
                    color: "lightblue"
                    },
                    periods: [
                    {
                        id: 22323,
                        start: {
                        hour: 0,
                        minute: 0,
                        },
                        end: {
                        hour: 24,
                        minute: 0,
                        },
                    },
                    ]
                },
                {
                    id: 3,
                    name: "Greta Henriksson",
                    role: {
                    name: "Pupil",
                    color: "pink"
                    },
                    periods: [
                    {
                        start: {
                        hour: 0,
                        minute: 0,
                        },
                        end: {
                        hour: 24,
                        minute: 0,
                        },
                    }
                    ]
                },
                ]
            },
            {
                id: 5,
                date: new Date().addDays(4),
                note: "Båten in på service",
                persons: [
                {
                    id: 1,
                    name: "Anders Bengtsson",
                    role: {
                    name: "Rescue runner",
                    color: "lightgreen"
                    },
                    periods: [
                    {
                        id: 333333333,
                        start: {
                        hour: 0,
                        minute: 0,
                        },
                        end: {
                        hour: 24,
                        minute: 0,
                        },
                    },
                    ],
                },
                {
                    id: 2,
                    name: "Cecilia Davidsson",
                    role: {
                    name: "Captain",
                    color: "lightblue"
                    },
                    periods: [
                    {
                        id: 22323,
                        start: {
                        hour: 0,
                        minute: 0,
                        },
                        end: {
                        hour: 14,
                        minute: 0,
                        },
                    },
                    {
                        id: 2264653,
                        start: {
                        hour: 16,
                        minute: 15,
                        },
                        end: {
                        hour: 24,
                        minute: 0,
                        },
                    },
                    ]
                },
                {
                    id: 3,
                    name: "Erik Fredriksson",
                    role: {
                    name: "Pupil",
                    color: "pink"
                    },
                    periods: [
                    {
                        start: {
                        hour: 0,
                        minute: 0,
                        },
                        end: {
                        hour: 24,
                        minute: 0,
                        },
                    }
                    ]
                },
                {
                    id: 4,
                    name: "Greta Henriksson",
                    role: {
                    name: "Pupil",
                    color: "pink"
                    },
                    periods: [
                    {
                        start: {
                        hour: 0,
                        minute: 0,
                        },
                        end: {
                        hour: 24,
                        minute: 0,
                        }
                    }
                    ]
                },
                ]
            },
            ]
        }
    },
    computed: {
      chartWidth() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 345
          case 'sm': return 400
          case 'md': return 500
          case 'lg': return 600
          case 'xl': return 800
        }
        return 0
      },
    },
}
</script>

<style>

</style>